import { h } from 'vue';

const INIT = 0;
const INPUT = 1;

const status = ['INIT', 'INPUT', 'CHANGED'];
const changedLog = debug=>{
    if(!debug) return ()=>false
    console.warn("`@packy-tang/vue-tinymce`进入debug模式");
    return (e, _status, val, oldVal)=>console.log(`来自：%s | 状态：%s \n %s \n %s`, e.type, status[_status], val, oldVal)
};

var script = {
    name: "VueTinymce",
    model: {
        prop: "content",
        event: "change"
    },
    props: {
        content: {
            type: [String, Object],
            default: ''
        },
        setup: {
            type: Function,
            default: function(){}
        },
        disabled: {
            type: Boolean,
            default: false
        },
        setting: {
            type: Object,
            default: function(){ 
                return {};
            }
        },
        debug: Boolean
    },
    render(){
        if(typeof tinymce === "undefined"){
            return h('div', "tinymce is undefined"); 
        }
        return h('div', {
            attrs: {
                id: this.id
            }
        });
    },
    data(){
        return {
            id: 'vue-tinymce-'+Date.now()+Math.floor(Math.random() * 1000),
            editor: null,
            status: INIT,
            bookmark: null
        }
    },
    watch: {
        content(val, oldVal){
            this.changedLog({ type: "propsChanged" }, this.status, `${val} | ${oldVal}`, "--");
            if(this.status === INPUT || oldVal === val) return;
            if(!this.editor || !this.editor.initialized) return; // fix editor plugin is loading and set content will throw error.
            if(val === null) return this.resetContent("");
            this.setContent(val);
        },
        disabled(val){
            this.editor.setMode(val?"readonly":"design");
        }
    },
    created(){
        this.changedLog = changedLog(this.debug);
        if(typeof tinymce === "undefined") throw new Error('tinymce undefined');
    },
    beforeMount () {
        const setting = Object.assign({},
            this.setting,
            {
                selector: '#'+this.id,
                setup: (editor)=> {
                    this.setup(editor);
                    // console.log('setup');
                    editor.on('init', ()=>{
                        // console.log('init', this.content);
                        this.setContent(this.content, editor);
                        editor.on('keyup input', e=>{ //只在编辑器中打字才会触发
                            this.status = INPUT;       //编辑器录入文字时标记为`INPUT`状态
                        });
                        editor.on('SetContent', e=>{ //编辑器在插入图片和撤销/重做时触发，组件content更新数据也会导致触发
                            this.changedLog(e, this.status, editor.getContent(), "--");
                        });
                        editor.on('Blur', e=>{
                            this.status = INIT;
                            this.changedLog(e, this.status, editor.getContent(), "--");
                        });
                        editor.on('input keyup Change Undo Redo ExecCommand NodeChange', e=>{
                            this.onChanged(e, editor);
                        });
                    });
                }
            }
        );
        this.editor = tinymce.createEditor(setting.selector, setting);
    },
    mounted(){
        this.editor.targetElm = this.$el;
        this.editor.render();
    },
    updated () {
        this.editor.render();
    },
    beforeDestroy: function(){
        this.editor.remove();
    },
    methods: {
        setContent(val, editor){
            if(!editor) editor = this.editor;
            editor.setContent(val);
            editor.selection.moveToBookmark(this.bookmark);
        },
        resetContent(val, editor){
            if(!editor) editor = this.editor;
            if(!!editor.resetContent) return editor.resetContent(val)
            editor.setContent(val);
            editor.setDirty(false);
            editor.undoManager.clear();
        },
        onChanged(e, editor){
            if(!editor) editor = this.editor;
            if(e.type === 'change') this.bookmark = e.level.bookmark;
            const content = editor.getContent();
            this.changedLog(e, this.status, content, "--");
            this.$emit('change', content);
        }
    }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

class VuePlugin{
    constructor(){
        const { prefix } = { prefix: "" };
        this.prefix = prefix;
    }
    install(Vue, options={}){
        const prefix = options.prefix || this.prefix;
        const components = {
            VueTinymce: __vue_component__
        };
        Object.keys(components).forEach(key => {
            const component = components[key];
            Vue.component(prefix+component.name, component);
        });
    }
}
var main = new VuePlugin();

export { __vue_component__ as VueTinymce, main as default };
//# sourceMappingURL=vue-tinymce.esm.js.map
